import LoginForm from "@/model/Form/LoginForm"
import loginForm from "@/state/loginForm"
import email from "@/state/email"

const resetLoginForm = async () => {
    loginForm.value = new LoginForm(email.value)
}

export default resetLoginForm
